import React from 'react';
const logo = require('../../../assets/images/adaptive-icon.png');

export const LogoSection = () => (
  <>
    <img src={logo} alt="login" className="w-56 h-56" />
    <p className="font-boldItalic !text-todoister text-2xl">TODOISTER</p>
  </>
);
